import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostBinding
} from '@angular/core';

@Component({
    selector: 'app-decoration-pixelization',
    templateUrl: './decoration-pixelization.component.pug',
    styleUrls: [
        './decoration-pixelization.component.less',
        './pixels.less',
        './pixels-rarity-colorfull.less'
    ]
})
export class DecorationPixelizationComponent {
    @Input() processing: boolean = false;
    @HostBinding('class.--processing') get isProcessing() {
        return this.processing;
    }

    @Output() click: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }
}
